import React from 'react';

const Home = () => {
  return <div>Home2</div>;
};

export default Home;
